export default __webpack_public_path__ + "static/03-a-underline-empower-0e5a37966de4dbb57574f9fb5368e045.svg";